module.exports = __webpack_public_path__ + "img/58.234476b3.jpg";